import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الجرعة اليومية للباراسيتامول للأطفال";
const DESCRIPTION =
  "استخدم هذه الحاسبة لحساب الجرعة اليومية المناسبة من الباراسيتامول بناءً على وزن الطفل وتركيز الدواء.";
const KEYWORDS = "الجرعات, حاسبة الجرعات, دواء, وزن الطفل, باراسيتامول";
const OG_URL =
  "https://do-calculate.com/calculator/ar/children-paracetamol-dosage-calculator/";
function ParacetamolDosageCalculator() {
  const [weight, setWeight] = useState("");
  const [concentration, setConcentration] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const calculateDosage = () => {
    try {
      if (weight < 44 && concentration) {
        let singleDose;
        const weightNum = parseFloat(weight);
        if (concentration === "160mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.25;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 1.87;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 2.5;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 3.75;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 5;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 7.5;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 10;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 12.5;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 15;
        } else if (concentration === "120mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.6;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 2.5;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 3.3;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 5;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 6.6;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 10;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 13.3;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 16.6;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 20;
        } else if (concentration === "125mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.6;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 2.4;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 3.2;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 4.8;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 6.4;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 9.6;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 12.8;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 16;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 19.2;
        } else if (concentration === "100mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 0.4;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 0.6;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 0.8;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 1.2;
          else if (weightNum >= 11 && concentration === "100mg/5ml") {
            setError("يرجى إدخال وزن ما بين 2.7 و 10.9 للتركيز 100 mg/ml");
            return;
          }
        }
        const totalDose = singleDose * 5;
        setResult({
          singleDose,
          totalDose,
        });
      }
      if (weight > 43.9) {
        setError("يرجى إدخال الوزن ما بين 2.7 و 43.9");
        return;
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة الجرعة اليومية للباراسيتامول مصممة خصيصًا للأهل
                  لمساعدتهم في حساب جرعة الباراسيتامول بدقة. لا حاجة إلى حسابات
                  معقدة، فقط أدخل البيانات المطلوبة واحصل على الجرعة الصحيحة.
                  آمنة وموثوقة، مثالية للاستخدام المنزلي.
                </p>
                <p>
                  حاسبة جرعة باراسيتامول سهلة الاستخدام تساعدك على تحديد الجرعة
                  الدوائية المثالية لطفلك بناءً على وزنه وتركيز الدواء. أدخل
                  البيانات المطلوبة واحصل على الجرعات بشكل مفصل. مثالية للأهل
                  والأطباء."
                </p>
                <p>
                  <b>
                    ملاحظة هامة: يجب التأكيد دائماً على أن هذه الأداة هي أداة
                    مساعدة فقط، ولا يجب الاعتماد عليها كبديل عن استشارة الطبيب.
                  </b>
                </p>
                <p>
                  تم تطوير الحاسبة بناءاً على{" "}
                  <a
                    href="https://www.sfda.gov.sa/ar/paracetamol-calculator"
                    rel="nofollow"
                  >
                    الهيئة العامة للغذاء والدواء في السعودية
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="weight">
                      <label className="form-label ms-2">ادخل الوزن (كغ)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="أدخل وزن الطفل"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="concentration"
                      >
                        اختر تركيز الباراسيتامول
                      </label>
                      <select
                        id="concentration"
                        value={concentration}
                        onChange={(e) => setConcentration(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">اختر تركيز الدواء</option>
                        <option value="120mg/5ml">120mg/5ml</option>
                        <option value="125mg/5ml">125mg/5ml</option>
                        <option value="160mg/5ml">160mg/5ml</option>
                        <option value="100mg/5ml">
                          100mg/5ml (أقل من سنتين)
                        </option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={calculateDosage}
                      disabled={!concentration}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">
                        الجرعة الواحدة: {result.singleDose} ml
                      </p>
                      <p className="text-white">
                        الجرعة اليومية: {result.totalDose} ml
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هي الجرعة اليومية؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>تعريف الجرعة اليومية</h2>{" "}
                  </u>
                  <p>
                    الجرعة اليومية هي كمية الدواء التي يحتاج الطفل لتناولها خلال
                    يوم واحد، وتختلف بناءً على وزن الطفل وتركيز الدواء.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    تحديد الجرعة المناسبة هو أمر ضروري لضمان سلامة الطفل.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيف يتم حساب الجرعة؟</h2>{" "}
                  </u>
                  <p>
                    يتم حساب الجرعة بناءً على معادلات تعتمد على وزن الطفل وتركيز
                    الدواء.
                  </p>
                  <p>
                    مثال: إذا كان وزن الطفل 5 كغ وتركيز الدواء 160mg/5ml، فإن
                    الجرعة الواحدة تكون 1.87 ml.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    تأكد دائمًا من اتباع تعليمات الطبيب أو الصيدلي.
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default ParacetamolDosageCalculator;
